import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import app from './config';

export const FUNCTIONS_REGION = 'europe-west1';

// null ohne Firebase-Konfiguration - siehe config.js.
//
// Das SDK cacht die Functions-Instanz pro App+Region. Weil wir hier die
// Instanz selbst exportieren statt getFunctions() an jeder Aufrufstelle neu
// aufzurufen, kann es gar nicht erst zu einer Reihenfolge-Frage beim
// Emulator-connect kommen.
const functions = app ? getFunctions(app, FUNCTIONS_REGION) : null;

if (functions && process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export default functions;
